import React from "react";
import { Dropdown as AntDropdown } from "antd";

/**
 * Wrapper component for Ant Design Dropdown
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Dropdown functionality including trigger, placement, and overlay options.
 *
 * @component
 * @example
 * import { Dropdown, Menu, Button } from '../GeneralComponents/ui';
 *
 * const menu = (
 *   <Menu>
 *     <Menu.Item key="1">1st menu item</Menu.Item>
 *     <Menu.Item key="2">2nd menu item</Menu.Item>
 *   </Menu>
 * );
 *
 * <Dropdown overlay={menu} placement="bottomLeft">
 *   <Button>bottomLeft</Button>
 * </Dropdown>
 *
 * @see https://ant.design/components/dropdown/ - Ant Design Dropdown documentation
 */
const Dropdown = (props) => {
  return (
    <AntDropdown
      {...props}
      destroyPopupOnHide={
        typeof props.destroyPopupOnHide === "boolean"
          ? props.destroyPopupOnHide
          : true
      }
      style={{ borderRadius: 16, ...props.style }}
      overlayStyle={{ borderRadius: 16, ...props.overlayStyle }}
    />
  );
};

export default Dropdown;
